import React, { useState } from 'react';
import { DialogContent, Grid, CircularProgress, Typography } from "@material-ui/core";
import { useBuilderPreview } from '../../../utilities/useBuilderPreview';
import { useAppConfig } from '../../../utilities/useAppConfig';
import { useEffect } from 'react';
import { AuthenticationService } from '../../../services/AuthenticationService';
import { EventTracking } from '../../../utilities/Tracking/EventTracking';
import { AddAssetAction } from '../../../entities/AddAssetAction';

interface IFramePayload {
    message:string,
    height?: number
}

export function BundleCheckoutDialog() {
    const [config, ] = useAppConfig();
    const previewContext = useBuilderPreview();
    const [loading, setLoading] = useState<boolean>(true);
    const [iframeHeight, setIframeHeight] = useState<number>(0);

    useEffect(() => {
        async function handleIframeMessage(e:MessageEvent){
            if(e.data as IFramePayload){
                const payload:IFramePayload = e.data;
                switch(payload.message){
                    case "loadingCompleted":
                        setIframeHeight(payload.height ?? 0);
                        setLoading(false);
                        break;
                    case "bundleCreated":
                        EventTracking.Subscribe.onNewSubscription(4.99, AddAssetAction.ImportSermonFromSC);
                        const result = await AuthenticationService.getAuthenticatedUser()
                        if(result.success){
                            previewContext.updateUser(result.data);
                        } else {
                            previewContext.updateUser(null);
                        }
                        break;
                }
            }
        }

        window.addEventListener("message", handleIframeMessage)
        return () => window.removeEventListener("message", handleIframeMessage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    if(previewContext.user === null){
        return null;
    }

    return (
        <DialogContent>
                {loading &&
                <Grid container justifyContent="center" alignItems="center" direction="column" >
                    <Grid item>
                        <div style={{ textAlign: "center"}}>
                            <CircularProgress style={{ marginTop: "50px" }} />
                            <br />
                            <Typography variant="body1" color="textSecondary" style={{ textAlign: "center" }}>
                                Loading...
                            </Typography>
                        </div>
                    </Grid>
                </Grid> 
                }
                <iframe
                    id="BundleIframe"
                    title="bundleCheckout" 
                    src={`${config.paymentsSiteUrl}/subscribe/bundle`}
                    loading="eager"
                    style={{
                        border: "none",
                        height: iframeHeight,
                        width: 500,
                    }}
                />           
        </DialogContent>
    );
}